module.exports = __webpack_public_path__ + "static/media/ReprojectionImage.e4f84c0d.jpg";